import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";
import { UpdateConfigRequest } from "interfaces/requests/Configs";

const BASE_URL = "/configs";

export const fetchConfigs = createAsyncThunk("configs/get", async () => {
  try {
    const response = await axios.get(`${BASE_URL}`);
    return response.data.data;
  } catch (error: any) {
    console.log("Error - fetchConfigs ->", error);
    throw new Error(error.message);
  }
});

export const updateConfigs = createAsyncThunk(
  "configs/patch",
  async (data: UpdateConfigRequest) => {
    try {
      const response = await axios.patch(`${BASE_URL}/`, data);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
);

export const getConfigById = createAsyncThunk(
  "configs/get/:id",
  async (id: string) => {
    try {
      const response = await axios.get(`${BASE_URL}/${id}`);
      return response.data.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
);
